import { useFeatureFlags } from "~/contexts/featureFlagProvider";
import { isOutputTemplatesDefaultEnabled, outputTemplatesEnabled } from "~/shared/constants/feature-flag.constants";

/**
 * Client mirror of `ensureOutputTemplatesEnabled` — keep defaults aligned with
 * `src/server/domain/output-templates/ensure-output-templates-enabled.ts`.
 *
 * The per-org beta gate, separate from `outputTemplates.access`: the permission says who inside an
 * org may use the builder, this says whether the org is in the beta. A surface that shows the
 * feature needs both, which is why this is not folded into `useCanAccessOutputTemplates`.
 */
export const useOutputTemplatesEnabled = (): boolean => {
  const { getFeatureFlag } = useFeatureFlags();
  return getFeatureFlag(outputTemplatesEnabled, isOutputTemplatesDefaultEnabled());
};
